import { b as __awaiter, e as __generator, d as __assign, g as __spread, _ as __makeTemplateObject, a as __extends, C as ClientSDKProxyContext } from '../../chunks/chunk-525a49bc.js';
import { Spin } from 'antd';
import React, { Component } from 'react';
import styled from 'styled-components';
import { E as ERROR_NO_SDK_CLIENT } from '../../chunks/chunk-bc685b06.js';
import moment from 'moment';
import { AxisDisplayMode, DataProvider, AxisPlacement, LineChart } from '@cognite/griff-react';
import { g as getColorByString } from '../../chunks/chunk-65cf8e1d.js';
import numeral from 'numeral';

var DataLoader = /** @class */ (function () {
    function DataLoader(sdkClient) {
        var _this = this;
        this.sdkClient = sdkClient;
        this.timeseries = {
            results: new Map(),
            requests: new Map(),
        };
        this.SERIES_GETTERS = new Map();
        this.requestsInFlight = {};
        this.getSubdomain = function (id) {
            return id
                ? (_this.SERIES_GETTERS.get(id) || { subDomain: [0, 1] }).subDomain
                : [0, 1];
        };
        this.getGranularity = function (id) {
            return id
                ? (_this.SERIES_GETTERS.get(id) || { granularity: '1d' }).granularity
                : '1d';
        };
        this.getTimeSeries = function (id) {
            if (_this.timeseries.requests.has(id)) {
                // @ts-ignore - We're checking for undefined with the "has" check.
                return _this.timeseries.requests.get(id);
            }
            if (_this.timeseries.results.has(id)) {
                // @ts-ignore - We're checking for undefined with the "has" check.
                return _this.timeseries.results.get(id);
            }
            var promise = _this.sdkClient.timeseries
                .retrieve([{ id: id }])
                .then(function (timeseriesList) {
                _this.timeseries.results = _this.timeseries.results.set(id, Promise.resolve(timeseriesList[0]));
                _this.timeseries.requests.delete(id);
                return timeseriesList[0];
            });
            _this.timeseries.requests = _this.timeseries.requests.set(id, promise);
            return promise;
        };
        this.getRawDataPoints = function (_a) {
            var id = _a.id, step = _a.step, start = _a.start, end = _a.end, limit = _a.limit;
            return _this.sdkClient.datapoints
                .retrieve({
                items: [
                    {
                        id: id,
                        start: start,
                        end: end,
                        limit: limit,
                    },
                ],
            })
                .then(function (data) {
                var temp = data[0].datapoints;
                return temp.map(function (d) {
                    var _a;
                    return _a = {},
                        _a["" + (step ? 'stepInterpolation' : 'average')] = d.value,
                        _a.timestamp = d.timestamp,
                        _a;
                });
            });
        };
        this.cogniteloader = function (_a) {
            var id = _a.id, baseDomain = _a.timeDomain, subDomain = _a.timeSubDomain, pointsPerSeries = _a.pointsPerSeries, oldSeries = _a.oldSeries, reason = _a.reason;
            return __awaiter(_this, void 0, void 0, function () {
                var fetchDomain, granularity, startTime, xAccessor, oldData, step, requestPromise, newDatapoints, seriesInfo;
                var _this = this;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            fetchDomain = (reason === 'MOUNTED' ? baseDomain : subDomain).map(Math.round);
                            granularity = DataLoader.calculateGranularity(fetchDomain, pointsPerSeries);
                            if (!(reason === 'INTERVAL')) return [3 /*break*/, 2];
                            if (this.requestsInFlight[id]) {
                                return [2 /*return*/, oldSeries];
                            }
                            this.requestsInFlight[id] = true;
                            startTime = baseDomain[0];
                            xAccessor = oldSeries.xAccessor, oldData = oldSeries.data;
                            if (oldData && oldData.length > 0) {
                                startTime = xAccessor(oldData[oldData.length - 1]) + 1;
                            }
                            step = oldSeries.step;
                            requestPromise = oldSeries.drawPoints
                                ? this.getRawDataPoints({
                                    id: id,
                                    start: startTime,
                                    end: Date.now(),
                                    step: step,
                                })
                                : this.sdkClient.datapoints
                                    .retrieve({
                                    items: [
                                        {
                                            id: id,
                                            start: startTime,
                                            end: Date.now(),
                                            granularity: granularity,
                                            aggregates: [
                                                'count',
                                                'min',
                                                'max',
                                                step ? 'stepInterpolation' : 'average',
                                            ],
                                        },
                                    ],
                                })
                                    .then(function (data) {
                                    return data.length === 0 ? [] : data[0].datapoints;
                                });
                            return [4 /*yield*/, requestPromise];
                        case 1:
                            newDatapoints = (_b.sent()).map(function (x) { return (__assign(__assign({}, x), { timestamp: +x.timestamp })); });
                            this.requestsInFlight[id] = false;
                            if (oldData) {
                                return [2 /*return*/, __assign(__assign({}, oldSeries), { data: __spread(oldData, newDatapoints) })];
                            }
                            return [2 /*return*/, __assign(__assign({}, oldSeries), { data: newDatapoints })];
                        case 2:
                            seriesInfo = this.SERIES_GETTERS.get(id) || {
                                firstSeries: [],
                                subDomain: subDomain,
                                granularity: granularity,
                            };
                            if (fetchDomain[1] - fetchDomain[0] < 100) {
                                // Zooming REALLY far in (1 ms end to end)
                                return [2 /*return*/, oldSeries];
                            }
                            return [2 /*return*/, this.getTimeSeries(id).then(function (timeseriesResponse) {
                                    var step = timeseriesResponse.isStep;
                                    return (_this.sdkClient.datapoints
                                        .retrieve({
                                        items: [
                                            {
                                                id: id,
                                                granularity: granularity,
                                                aggregates: [
                                                    'count',
                                                    'min',
                                                    'max',
                                                    step ? 'stepInterpolation' : 'average',
                                                ],
                                                start: fetchDomain[0],
                                                end: fetchDomain[1],
                                                limit: pointsPerSeries,
                                            },
                                        ],
                                    })
                                        .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                                        var points, numberOfPoints, data;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    points = response[0].datapoints;
                                                    numberOfPoints = points.reduce(function (p, c) {
                                                        // @ts-ignore
                                                        return p + (c.count || 0);
                                                    }, 0);
                                                    if (!(numberOfPoints < pointsPerSeries / 2)) return [3 /*break*/, 2];
                                                    return [4 /*yield*/, this.getRawDataPoints({
                                                            id: id,
                                                            step: step,
                                                            start: fetchDomain[0],
                                                            end: fetchDomain[1],
                                                            limit: pointsPerSeries,
                                                        })];
                                                case 1:
                                                    data = _a.sent();
                                                    if (step && points.length) {
                                                        // Use the last-known value from step-interpolation to create a fake point at the left-boundary
                                                        if (data.length && points[0].timestamp < data[0].timestamp) {
                                                            data = __spread([points[0]], data);
                                                        }
                                                        else if (!data.length) {
                                                            data = [points[0]];
                                                        }
                                                    }
                                                    return [2 /*return*/, {
                                                            data: data,
                                                            drawPoints: true,
                                                            step: step,
                                                        }];
                                                case 2: return [2 /*return*/, {
                                                        // @ts-ignore
                                                        data: points.map(function (x) { return (__assign(__assign({}, x), { timestamp: +x.timestamp })); }),
                                                        step: step,
                                                    }];
                                            }
                                        });
                                    }); })
                                        .then(function (newSeries) {
                                        var firstSeries = seriesInfo.firstSeries;
                                        var xAccessor = oldSeries.xAccessor;
                                        if (reason === 'UPDATE_SUBDOMAIN') {
                                            var val = _this.SERIES_GETTERS.get(id);
                                            _this.SERIES_GETTERS.set(id, __assign(__assign({}, val), { firstSeries: val ? val.firstSeries : [], subDomain: subDomain,
                                                granularity: granularity }));
                                            var data = DataLoader.mergeInsert(firstSeries, newSeries.data, xAccessor, subDomain);
                                            return __assign(__assign({}, newSeries), { data: data });
                                        }
                                        return newSeries;
                                    })
                                        .then(function (newSeries) {
                                        if (reason === 'MOUNTED') {
                                            var val = _this.SERIES_GETTERS.get(id);
                                            _this.SERIES_GETTERS.set(id, __assign(__assign({}, val), { firstSeries: newSeries.data, subDomain: subDomain,
                                                granularity: granularity }));
                                        }
                                        return __assign(__assign({}, newSeries), { yAccessor: DataLoader.yAccessor });
                                    })
                                        // Do not crash the app in case of error, just return no data
                                        .catch(function () {
                                        return { data: [], step: step };
                                    }));
                                })];
                    }
                });
            });
        };
    }
    DataLoader.determineIfIsDoubleDatapoint = function (toBeDetermined) {
        if (typeof toBeDetermined.value === 'number') {
            return true;
        }
        return false;
    };
    DataLoader.yAccessor = function (d) {
        if (DataLoader.determineIfIsDoubleDatapoint(d)) {
            return +d.value;
        }
        if (d.stepInterpolation !== undefined) {
            return +d.stepInterpolation;
        }
        if (d.average !== undefined) {
            return +d.average;
        }
        // We can get here if we ask for a stepInterpolation
        // and there's no points in the range [0, t1]
        // where the domain asked for is [t0, t1]
        return 0;
    };
    DataLoader.y0Accessor = function (data) {
        return data.min ? data.min : DataLoader.yAccessor(data);
    };
    DataLoader.y1Accessor = function (data) {
        return data.max ? data.max : DataLoader.yAccessor(data);
    };
    DataLoader.calculateGranularity = function (domain, pps) {
        var diff = domain[1] - domain[0];
        for (var i = 1; i <= 60; i += 1) {
            var points = diff / (1000 * i);
            if (points < pps) {
                return (i === 1 ? '' : i) + "s";
            }
        }
        for (var i = 1; i <= 60; i += 1) {
            var points = diff / (1000 * 60 * i);
            if (points < pps) {
                return (i === 1 ? '' : i) + "m";
            }
        }
        for (var i = 1; i < 24; i += 1) {
            var points = diff / (1000 * 60 * 60 * i);
            if (points < pps) {
                return (i === 1 ? '' : i) + "h";
            }
        }
        for (var i = 1; i < 100; i += 1) {
            var points = diff / (1000 * 60 * 60 * 24 * i);
            if (points < pps) {
                return (i === 1 ? '' : i) + "day";
            }
        }
        return 'day';
    };
    DataLoader.mergeInsert = function (base, toInsert, xAccessor, subDomain) {
        if (toInsert.length === 0) {
            return base;
        }
        // Remove the points from base within the subdoconstn
        var strippedBase = base.filter(function (point) {
            return xAccessor(point) < subDomain[0] || xAccessor(point) > subDomain[1];
        });
        return __spread(strippedBase, toInsert).sort(function (a, b) { return xAccessor(a) - xAccessor(b); });
    };
    return DataLoader;
}());

// Copyright 2020 Cognite AS
var countDecimals = function (num) {
    if (!Number.isNaN(num) && Math.floor(num) !== num) {
        return num.toString().split('.')[1].length || 0;
    }
    return 0;
};
var findMaxDecimals = function (array) {
    return array.reduce(function (max, current) { return Math.max(max, countDecimals(current)); }, 0);
};
var decimalTickFormatter = function (tick, ticks) {
    return tick.toFixed(findMaxDecimals(ticks));
};

var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  top: 0;\n  left: 0;\n  z-index: 100;\n"], ["\n  position: relative;\n  top: 0;\n  left: 0;\n  z-index: 100;\n"])));
var Overview = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  margin-left: -150px;\n  width: 140px;\n  background: #fff;\n  padding: 8px 16px 10px;\n  pointer-events: none;\n  opacity: 0.9;\n  border-radius: 4px;\n  border: 1px solid #888888;\n  box-sizing: border-box;\n"], ["\n  position: absolute;\n  top: 0;\n  margin-left: -150px;\n  width: 140px;\n  background: #fff;\n  padding: 8px 16px 10px;\n  pointer-events: none;\n  opacity: 0.9;\n  border-radius: 4px;\n  border: 1px solid #888888;\n  box-sizing: border-box;\n"])));
var DateContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  margin-left: -230px;\n  width: 220px;\n  color: black;\n  background: #fff;\n  padding: 8px 16px 10px;\n  pointer-events: none;\n  opacity: 0.9;\n  border-radius: 4px;\n  border: 1px solid #888888;\n  box-sizing: border-box;\n"], ["\n  position: absolute;\n  top: 0;\n  margin-left: -230px;\n  width: 220px;\n  color: black;\n  background: #fff;\n  padding: 8px 16px 10px;\n  pointer-events: none;\n  opacity: 0.9;\n  border-radius: 4px;\n  border: 1px solid #888888;\n  box-sizing: border-box;\n"])));
var Tag = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: black;\n  &:before {\n    content: '';\n    display: inline-block;\n    width: 10px;\n    height: 10px;\n    border-radius: 100%;\n    margin: 0 8px 0 2px;\n    background: ", ";\n  }\n"], ["\n  color: black;\n  &:before {\n    content: '';\n    display: inline-block;\n    width: 10px;\n    height: 10px;\n    border-radius: 100%;\n    margin: 0 8px 0 2px;\n    background: ", ";\n  }\n"])), function (props) { return (props.color ? props.color : '#6c6c6c'); });
var formattedDate = function (timestamp) {
    return moment(timestamp).format('MMM D, YYYY HH:mm:ss');
};
var CursorOverview = /** @class */ (function (_super) {
    __extends(CursorOverview, _super);
    function CursorOverview(props) {
        var _this = _super.call(this, props) || this;
        _this.overviewContainer = null;
        _this.dateContainer = null;
        _this.componentDidMount = function () {
            window.addEventListener('mousemove', _this.handleMouseMove);
        };
        _this.componentWillUnmount = function () {
            window.removeEventListener('mousemove', _this.handleMouseMove);
        };
        _this.handleMouseMove = function (e) {
            var wrapperRef = _this.props.wrapperRef;
            if (!wrapperRef) {
                return;
            }
            if (_this.overviewContainer) {
                _this.overviewContainer.setAttribute('style', "transform: translate(" + e.offsetX + "px,\n        " + (e.offsetY -
                    _this.overviewContainer.getBoundingClientRect().height / 2) + "px)");
            }
            if (_this.dateContainer && wrapperRef) {
                var lineChartRect = wrapperRef.getBoundingClientRect();
                _this.dateContainer.setAttribute('style', "transform: translate(" + e.offsetX + "px,\n        " + (lineChartRect.height - _this.dateContainer.clientHeight - 55) + "px)");
            }
        };
        _this.state = {
            overviewContainer: null,
        };
        return _this;
    }
    CursorOverview.prototype.render = function () {
        var _this = this;
        var _a = this.props, series = _a.series, hiddenSeries = _a.hiddenSeries, rulerPoints = _a.rulerPoints, _b = _a.ruler, timeLabel = _b.timeLabel, yLabel = _b.yLabel;
        if (!series ||
            !series.length ||
            !Object.keys(rulerPoints) ||
            !Object.keys(rulerPoints).length) {
            return null;
        }
        var newestTimestamp = Object.keys(rulerPoints).reduce(function (acc, id) {
            var rulerPoint = rulerPoints[id];
            return Math.max(rulerPoint.timestamp, acc);
        }, 0);
        var timeLabelFormatted = timeLabel
            ? timeLabel({
                id: 0,
                name: '',
                value: 0,
                color: '#ccddff',
                timestamp: newestTimestamp,
                x: 0,
                y: 0,
            })
            : formattedDate(newestTimestamp);
        var yLabelFormatter = yLabel
            ? yLabel
            : function (point) {
                return numeral(point.value).format('0[.]0[00] a');
            };
        var renderTag = function (_a) {
            var id = _a.id, color = _a.color;
            return rulerPoints[id] &&
                !hiddenSeries[id] && (React.createElement(Tag, { color: color, key: id }, yLabelFormatter(rulerPoints[id])));
        };
        return (React.createElement(Container, null,
            React.createElement(Overview, { ref: function (ref) { return (_this.overviewContainer = ref); } }, series && series.map(renderTag)),
            React.createElement(DateContainer, { ref: function (ref) { return (_this.dateContainer = ref); } }, timeLabelFormatted)));
    };
    return CursorOverview;
}(React.Component));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

// Don't allow updating faster than every 1000ms.
var MINIMUM_UPDATE_FREQUENCY_MILLIS = 1000;
var TimeseriesChart = /** @class */ (function (_super) {
    __extends(TimeseriesChart, _super);
    function TimeseriesChart(props, context) {
        var _this = _super.call(this, props) || this;
        _this.chartWrapper = null;
        _this.onFetchData = function () {
            if (!_this.state.loaded) {
                _this.setState({ loaded: true });
            }
        };
        _this.onMouseMove = function (data) {
            var onMouseMove = _this.props.onMouseMove;
            var _a = data.points, points = _a === void 0 ? [] : _a;
            var rulerPoints = {};
            points.forEach(function (point) {
                rulerPoints[point.id] = point;
            });
            _this.setState({ rulerPoints: rulerPoints });
            if (onMouseMove) {
                onMouseMove(data);
            }
        };
        _this.state = {
            loaded: false,
            rulerPoints: {},
        };
        if (!context) {
            console.error(ERROR_NO_SDK_CLIENT);
            return _this;
        }
        _this.client = context(TimeseriesChart.displayName || '');
        _this.dataLoader = new DataLoader(_this.client);
        return _this;
    }
    TimeseriesChart.prototype.render = function () {
        var _this = this;
        var _a = this.props, startTime = _a.startTime, endTime = _a.endTime, pointsPerSeries = _a.pointsPerSeries, 
        // @ts-ignore
        timeseriesIds = _a.timeseriesIds, 
        // @ts-ignore
        series = _a.series, collections = _a.collections, updateIntervalMillis = _a.updateIntervalMillis, zoomable = _a.zoomable, crosshair = _a.crosshair, contextChart = _a.contextChart, xAxisHeight = _a.xAxisHeight, timeseriesColors = _a.timeseriesColors, yAxisDisplayMode = _a.yAxisDisplayMode, styles = _a.styles, liveUpdate = _a.liveUpdate, yAxisPlacement = _a.yAxisPlacement, hiddenSeries = _a.hiddenSeries, annotations = _a.annotations, ySubDomains = _a.ySubDomains, ruler = _a.ruler, height = _a.height, width = _a.width, onMouseOut = _a.onMouseOut, onBlur = _a.onBlur, onFetchDataError = _a.onFetchDataError;
        var loaded = this.state.loaded;
        var griffSeries = series
            ? series.map(function (s) { return (__assign(__assign({}, s), { id: s.id, color: s.color ||
                    timeseriesColors[s.id] ||
                    getColorByString(s.id.toString()), yAxisDisplayMode: s.yAxisDisplayMode || AxisDisplayMode[yAxisDisplayMode], hidden: s.hidden || hiddenSeries[s.id], yAccessor: s.yAccessor || DataLoader.yAccessor, y0Accessor: s.y0Accessor || DataLoader.y0Accessor, y1Accessor: s.y1Accessor || DataLoader.y1Accessor, ySubDomain: s.ySubDomain })); })
            : timeseriesIds.map(function (id) { return ({
                id: id,
                color: timeseriesColors[id] || getColorByString(id.toString()),
                yAxisDisplayMode: AxisDisplayMode[yAxisDisplayMode],
                hidden: hiddenSeries[id],
                yAccessor: DataLoader.yAccessor,
                y0Accessor: DataLoader.y0Accessor,
                y1Accessor: DataLoader.y1Accessor,
                ySubDomain: ySubDomains ? ySubDomains[id] : undefined,
            }); });
        var showCrosshair = crosshair || ruler !== undefined;
        return (griffSeries.length !== 0 && (React.createElement(Spin, { spinning: !loaded },
            React.createElement(Wrapper, { style: styles && styles.container, ref: function (ref) { return (_this.chartWrapper = ref); } },
                React.createElement(DataProvider, { defaultLoader: this.dataLoader.cogniteloader, onFetchData: this.onFetchData, pointsPerSeries: pointsPerSeries, series: griffSeries, collections: __spread(new Set(Object.values(collections))).map(function (unit) { return ({
                        id: unit,
                        color: getColorByString(unit.toString()),
                        yAxisDisplayMode: AxisPlacement[yAxisPlacement],
                    }); }), timeDomain: [+startTime, +endTime], onFetchDataError: onFetchDataError
                        ? onFetchDataError
                        : function (e) {
                            throw e;
                        }, updateInterval: liveUpdate
                        ? Math.max(updateIntervalMillis, MINIMUM_UPDATE_FREQUENCY_MILLIS)
                        : 0 },
                    ruler && (React.createElement(CursorOverview, { wrapperRef: this.chartWrapper, series: griffSeries, hiddenSeries: hiddenSeries, rulerPoints: this.state.rulerPoints, ruler: ruler })),
                    React.createElement(LineChart, { zoomable: zoomable, crosshair: showCrosshair, annotations: annotations, contextChart: {
                            visible: contextChart,
                            height: 100,
                            isDefault: true,
                        }, height: height, width: width, yAxisFormatter: decimalTickFormatter, yAxisPlacement: AxisPlacement[yAxisPlacement], xAxisHeight: xAxisHeight, onMouseMove: this.onMouseMove, onMouseOut: onMouseOut, onBlur: onBlur }))))));
    };
    TimeseriesChart.displayName = 'TimeseriesChart';
    TimeseriesChart.contextType = ClientSDKProxyContext;
    TimeseriesChart.defaultProps = {
        startTime: Date.now() - 60 * 60 * 1000,
        endTime: Date.now(),
        pointsPerSeries: 600,
        updateIntervalMillis: 5000,
        zoomable: false,
        contextChart: false,
        crosshair: false,
        yAxisDisplayMode: 'ALL',
        liveUpdate: false,
        yAxisPlacement: 'RIGHT',
        height: undefined,
        width: undefined,
        timeseriesColors: {},
        hiddenSeries: {},
        annotations: [],
        xAxisHeight: 50,
        collections: {},
        ruler: undefined,
    };
    return TimeseriesChart;
}(Component));
var Wrapper = styled.div(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  height: 500px;\n  width: 100%;\n"], ["\n  height: 500px;\n  width: 100%;\n"])));
var templateObject_1$1;

export { TimeseriesChart };
